<script setup>
// import '@/styles/css/span-calculator.scss';
import { ref } from 'vue';
const tab = ref({
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false,
  8: false,
  9: false,
  10: false,
})
const type = ref(false)
</script>
<template>
  <div class="mb-[64px]"></div>
  <div class="bj a bk af bl bm bn bo">
    <div class="bp bn bq br">
      <div class="bs a bk bt">
        <div class="a bu">
          <div class="c a bv">
            <div class="a bw bx by bz ca cb cc">
              <a href="/" rel="norefer"
                ><span class="cd e au ar ce">Home</span></a
              >
            </div>
            <div class="a cf">
              <span class="cd e au ar ce"> <!-- -->/<!-- --> </span>
            </div>
          </div>
          <div class="c a bv">
            <div class="a bw bx by bz ca cb cc">
              <a href="/calculator/" rel="norefer"
                ><span class="cd e au ar ce">Calculators</span></a
              >
            </div>
            <div class="a cf">
              <span class="cd e au ar ce"> <!-- -->/<!-- --> </span>
            </div>
          </div>
          <div class="a bw bx by bz cg">
            <span class="q e f ar h">Margin Calculator</span>
          </div>
        </div>
        <div class="a ch">
          <h1 class="ci cj ck cl cm">Margin Calculator</h1>
        </div>
        <div class="a ch">
          <div tabindex="-1" class="bs a bk ag">
            <div class="bs bp cn co bn cp cq">
              <div
                tabindex="0"
                class="a bk bn cr cs ct cu cv cw cx cy cz da db dc dd de df dg dh di dj dk dl dm dn do dp dq"
              >
                <div class="a dr">
                  <div class="c a ds">
                    <span class="f dt du dv dw">Scrip Name &amp; Expiry</span
                    ><sup>*</sup>
                  </div>
                  <span class="dx dy dz f ea dt dv i">Clear</span>
                </div>
                <div class="c a cn">
                  <input class="!mb-0 !shadow-none" placeholder="NIFTY 50 19990 CE 28 SEP 23" value="" />
                  <div class="a eb i ec ed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      focusable="false"
                      class="q ee ef"
                    >
                      <defs></defs>
                      <path
                        stroke="currentColor"
                        stroke-width="2"
                        d="M22 22l-7-7m2-5.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="bs a bk">
                <div class="c a ds">
                  <span class="f dt du dv dw">Side</span><sup>*</sup>
                </div>
                <div :class="[!type?'a cv eg eh ei ej ek el em en eo ep eq er es et':'a cv eg eh ei ej ek el lh li eo ep lj lk ll lm']" @click="type=!type">
                  <div class="a cr bn ae eu ev ab ew i ex">
                    <input
                      type="checkbox"
                      checked=""
                      class="ey eb ez fa fb bn fc fd n"
                    />
                    <div :class="[!type?'eb fe ff fg aw fh ab ew':'eb ln ff fg aw lo ab ew']"></div>
                    <span
                    :class="[!type?'eb ez fa a c af ff fc fi fj at fk fl at e f g h':'eb ez fa a c af ff fc fi fj q fk fl at e f g h']"
                      >Buy</span
                    ><span
                      :class="[!type?'eb ez fa a c af ff fc fi fj q fk fl at e f g h':'eb ez fa a c af ff fc fi fj at fk fl at e f g h']"
                      >Sell</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="a bk fm cv fn fo fp fq dd fr fs ft fu fv fw fx fy fz ga"
              >
                <div class="a cn dr">
                  <div class="c a ds">
                    <span class="f dt du dv dw">Qty</span><sup>*</sup>
                  </div>
                  <div class="c a ds gb gc gd ge gf">
                    <span class="q e gg ar h">1 lot X 1</span>
                  </div>
                </div>
                <div class="a bk">
                  <div class="a bk gh gi gj gk">
                    <label for="stepInput" class="q e f g h"></label>
                    <div class="gl fg ay cr gm gn c go dr">
                      <div class="c a dr gp gq gr gs">
                        <div class="a">
                          <button disabled="" class="a gt gu cj i !bg-transparent !p-0">-</button>
                        </div>
                        <input
                          type="text"
                          id="stepInput"
                          value="1"
                          class="q e f ar gv fg bn gw gx gy gz m ha hb hc hd he hf bs a !bg-transparent"
                        />
                        <div class="ev hg hh fa hi fk eb hj ez hk hl"></div>
                        <div class="a">
                          <button class="a cm gu cj i !bg-transparent !p-0">+</button>
                        </div>
                        <div class="a"></div>
                      </div>
                    </div>
                    <span data-qa="info-message" class="cd e au ar ce"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="bp cn dr bn hm cq">
              <div class="a hn ho hp hq">
                <button
                  type="button"
                  id="add-position-button"
                  disabled=""
                  class="at e f x y c av ab aw i a ae af ag ah ai az ba bb bc bd be bf n bg bh bi"
                >
                  Add Position
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="a ch">
          <div style="border: 0.5px solid #b1b1b1" class="bs a"></div>
        </div>
        <div class="a ch">
          <div class="bs a bk hr hs hg">
            <div class="a cn ht bn hu hv">
              <div class="a bk dr bn hw hx hy hz ia ib ic">
                <span class="q e f g h">Req. margin<!-- -->:</span
                ><span class="q e f g h">₹0.00</span>
              </div>
              <div class="a bk dr bn hw hx hy hz ia ib ic">
                <span class="q e f g h">Margin benefit<!-- -->:</span
                ><span class="q e f g h">₹0.00</span>
              </div>
              <div class="a bk dr bn hw hx hy hz ia ib ic">
                <span class="q e f g h">Final margin<!-- -->:</span
                ><span class="q e f g h">₹0.00</span>
              </div>
            </div>
            <div class="a ht">
              <div style="border: 0.5px solid #b1b1b1" class="bs a"></div>
            </div>
            <div style="cursor: pointer" class="c bs a id">
              <span class="f ea dt dv ie if">Refresh for latest quotes</span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.99967 16.6668C8.13856 16.6668 6.56217 16.0209 5.27051 14.7293C3.97884 13.4376 3.33301 11.8612 3.33301 10.0001C3.33301 8.13899 3.97884 6.5626 5.27051 5.27094C6.56217 3.97927 8.13856 3.33344 9.99967 3.33344C10.958 3.33344 11.8747 3.53135 12.7497 3.92719C13.6247 4.32302 14.3747 4.88899 14.9997 5.6251V3.33344H16.6663V9.16677H10.833V7.5001H14.333C13.8886 6.72232 13.2809 6.11121 12.5101 5.66677C11.7393 5.22232 10.9025 5.0001 9.99967 5.0001C8.61079 5.0001 7.43023 5.48621 6.45801 6.45844C5.48579 7.43066 4.99967 8.61121 4.99967 10.0001C4.99967 11.389 5.48579 12.5695 6.45801 13.5418C7.43023 14.514 8.61079 15.0001 9.99967 15.0001C11.0691 15.0001 12.0344 14.6945 12.8955 14.0834C13.7566 13.4723 14.3608 12.6668 14.708 11.6668H16.458C16.0691 13.139 15.2775 14.3404 14.083 15.2709C12.8886 16.2015 11.5275 16.6668 9.99967 16.6668Z"
                  fill="#B1B1B1"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="a ch">
          <div class="bs a bk">
            <div class="a dr ig ih ii ij">
              <div class="c a ik ii hx il"><span>Your orders</span></div>
              <div class="c a af im fg in io ip iq ir du dz is ea dt it iu">
                Smart Sequencing
              </div>
            </div>
            <div class="bs a bk">
              <div class="a af ig iv hg">
                <div class="bs a cn dr iw">
                  <div class="c bs a cn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7.49558 16C7.08186 16 6.72917 15.8527 6.4375 15.5581C6.14583 15.2635 6 14.9093 6 14.4956C6 14.0819 6.14731 13.7292 6.44192 13.4375C6.73654 13.1458 7.09071 13 7.50442 13C7.91814 13 8.27083 13.1473 8.5625 13.4419C8.85417 13.7365 9 14.0907 9 14.5044C9 14.9181 8.85269 15.2708 8.55808 15.5625C8.26346 15.8542 7.90929 16 7.49558 16ZM12.4956 16C12.0819 16 11.7292 15.8527 11.4375 15.5581C11.1458 15.2635 11 14.9093 11 14.4956C11 14.0819 11.1473 13.7292 11.4419 13.4375C11.7365 13.1458 12.0907 13 12.5044 13C12.9181 13 13.2708 13.1473 13.5625 13.4419C13.8542 13.7365 14 14.0907 14 14.5044C14 14.9181 13.8527 15.2708 13.5581 15.5625C13.2635 15.8542 12.9093 16 12.4956 16ZM7.49558 11.5C7.08186 11.5 6.72917 11.3527 6.4375 11.0581C6.14583 10.7635 6 10.4093 6 9.99558C6 9.58186 6.14731 9.22917 6.44192 8.9375C6.73654 8.64583 7.09071 8.5 7.50442 8.5C7.91814 8.5 8.27083 8.64731 8.5625 8.94192C8.85417 9.23654 9 9.59071 9 10.0044C9 10.4181 8.85269 10.7708 8.55808 11.0625C8.26346 11.3542 7.90929 11.5 7.49558 11.5ZM12.4956 11.5C12.0819 11.5 11.7292 11.3527 11.4375 11.0581C11.1458 10.7635 11 10.4093 11 9.99558C11 9.58186 11.1473 9.22917 11.4419 8.9375C11.7365 8.64583 12.0907 8.5 12.5044 8.5C12.9181 8.5 13.2708 8.64731 13.5625 8.94192C13.8542 9.23654 14 9.59071 14 10.0044C14 10.4181 13.8527 10.7708 13.5581 11.0625C13.2635 11.3542 12.9093 11.5 12.4956 11.5ZM7.49558 7C7.08186 7 6.72917 6.85269 6.4375 6.55808C6.14583 6.26346 6 5.90929 6 5.49558C6 5.08186 6.14731 4.72917 6.44192 4.4375C6.73654 4.14583 7.09071 4 7.50442 4C7.91814 4 8.27083 4.14731 8.5625 4.44192C8.85417 4.73654 9 5.09071 9 5.50442C9 5.91814 8.85269 6.27083 8.55808 6.5625C8.26346 6.85417 7.90929 7 7.49558 7ZM12.4956 7C12.0819 7 11.7292 6.85269 11.4375 6.55808C11.1458 6.26346 11 5.90929 11 5.49558C11 5.08186 11.1473 4.72917 11.4419 4.4375C11.7365 4.14583 12.0907 4 12.5044 4C12.9181 4 13.2708 4.14731 13.5625 4.44192C13.8542 4.73654 14 5.09071 14 5.50442C14 5.91814 13.8527 6.27083 13.5581 6.5625C13.2635 6.85417 12.9093 7 12.4956 7Z"
                        fill="#B1B1B1"
                      ></path>
                    </svg>
                    <div class="a ix">
                      <span class="cd e f ar h">Add a position </span>
                    </div>
                  </div>
                  <div class="c bs a cn iy">
                    <span class="cd e f ar h">0 Qty </span>
                    <div class="c a af iz cf ja jb jc jd je g jf i">B/S</div>
                    <div class="a">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        focusable="false"
                        cursor="pointer"
                        style="color: #b1b1b1"
                        class="q ee ef"
                      >
                        <defs></defs>
                        <path
                          stroke="currentColor"
                          stroke-width="2"
                          d="M19 9l-7 7-7-7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bs a bk">
          <div class="bs a jg">
            <span class="is cj it cm jh !my-0">Frequently Asked Questions</span>
          </div>
          <div class="bs a bk">
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[1]?'co':'jk']" @click="tab[1]=!tab[1]">
                <h2 class="is cj it cm jh !my-0">
                  What is the span margin calculator?
                </h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path :d="tab[1]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[1]" class="a hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h">The span margin calculator helps traders compute the margin (capital) required for initiating a trade in the NSE equity derivatives/commodity derivatives and currency derivatives segments before actually taking the trade.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[2]?'co':'jk']" @click="tab[2]=!tab[2]">
                <h2 class="is cj it cm jh !my-0">
                  How does the span margin calculator work?
                </h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[2]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[2]" class="bs a bk hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h"><a href="https://www.nseindia.com/" target="_blank">The objective of span</a> is to identify overall risk in a portfolio of futures and options contracts for each member.</span><span class="q e f ar h">In standard pricing models, three factors most directly affect the value of an option at a given point in time:</span><div class="a bk"><ol type="1"><li>Underlying market price</li><li>Volatility (variability) of underlying instrument</li><li>Time to expiration</li></ol></div><span class="q e f ar h">As these factors change, so too will the value of futures and options maintained within the portfolio. Span constructs scenarios of probable changes in underlying prices and volatilities in order to identify the largest loss a portfolio might suffer from one day to the next. It thensets the margin(capital) requirement at a level sufficient to cover this one-day loss.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[3]?'co':'jk']" @click="tab[3]=!tab[3]">
                <h2 class="is cj it cm jh !my-0">
                  How is the F&amp;O margin calculated?
                </h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path :d="tab[3]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[3]" class="a hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h">You can use the link to see F&amp;O calculation –<a href="/calculator/span-calculator/" target="_blank">https://upstox.com/calculator/span-calculator/</a> All you have to do is select the exchange, segment, ticker, whether you want to buy or sell and quantity. After you fill in the details and click on add you will see the required margin (capital) for initiating the trade.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[4]?'co':'jk']" @click="tab[4]=!tab[4]">
                <h2 class="is cj it cm jh !my-0">What are margins in equity?</h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[4]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[4]" class="bs a bk hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h">In equity the margins are called leverage. You are allowed to buy stocks by paying a marginal amount of the actual value. On Upstox, from 20th September 2021 onwards, you can now place intraday orders with up to <a href="/announcements/margins/#:~:text=across%20various%20products.-,Margin%20applicable%20on%20the%20intraday%20positions%20would%20be%3A%201.,for%20important%20updates%20from%20Upstox!" target="_blank">5x* leverage</a> on all NSE 500 stocks!</span><span class="q e f ar h">What’s changed? Earlier we offered up to 5x leverage only on equity stocks listed under the F&amp;O segment, but now you can avail up to 5x leverage to place intraday orders on all NSE 500 stocks.</span><span class="q e f ar h">*Please note: Leverages are subject to change without prior notice at Upstox’s discretion.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[5]?'co':'jk']" @click="tab[5]=!tab[5]">
                <h2 class="is cj it cm jh !my-0">What is the upfront margin?</h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[5]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[5]" class="bs a bk hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h"><a href="/announcements/margins/changes-in-margin-the-subsequent-penalty-applicable-from-1st-august-2020/" target="_blank">Upfront margins</a> means depositing initial margins upfront on the trading day if you wish to trade in any of the registered segment/s.</span><span class="q e f ar h">The following shall be continued to be considered as upfront margin:</span><div class="a bk"><ol type="1"><li>Funds available in the trading ledger with Upstox</li><li>Shares pledged* in favour of Upstox as collateral for margin purposes (only for POA clients)</li></ol></div><span class="q e f ar h">*A change is this system shall become applicable in the near future. Clients shall beappropriately informed about such change in advance.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[6]?'co':'jk']" @click="tab[6]=!tab[6]">
                <h2 class="is cj it cm jh !my-0">What is the exposure margin?</h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[6]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[6]" class="a hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h">The exposure margin is the margin blocked over and above the SPAN to cushion for any MTM losses. Both the SPAN and exposure margins are specified by the exchange. So at the time of initiating a futures trade, the client has to adhere to the initial margin requirement. The entire initial margin (SPAN + Exposure) is blocked by the exchange.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[7]?'co':'jk']" @click="tab[7]=!tab[7]">
                <h2 class="is cj it cm jh !my-0">
                  What is the value at risk margin?
                </h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[7]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[7]" class="bs a bk hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h"><a href="https://www.bqprime.com/financial-terms/what-is-value-at-risk-margin-definition-basics-and-meaning-of-var" target="_blank">Value at risk</a> (VaR) margin is a measure of risk. It is used to estimate the probability of loss of value of a share or a portfolio, based on the statistical analysis of historical price trends and volatilities. To arrive at VaR margin, three important parameters are considered.</span><div class="a bk"><ol type="1"><li>Confidence level</li><li>Time horizon</li><li>Estimate of loss</li></ol></div><span class="q e f ar h">VaR margin is published by the exchanges multiple times during the day, based onthe movement in price of a stock.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[8]?'co':'jk']" @click="tab[8]=!tab[8]">
                <h2 class="is cj it cm jh !my-0">What is the extreme loss margin?</h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[8]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[8]" class="a hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h">The extreme loss margin aims at covering the losses that could occur outside the coverage of VaR margins.</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[9]?'co':'jk']" @click="tab[9]=!tab[9]">
                <h2 class="is cj it cm jh !my-0">What is a ticker?</h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[9]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[9]" class="a hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h">A ticker is a symbol, a unique combination of letters and numbers that represent a particular stock. Fox example, ticker for Reliance is RIL</span></div>
            </div>
            <div class="bs a bk ji jj">
              <div class="c bs a dr" :class="[tab[10]?'co':'jk']" @click="tab[10]=!tab[10]">
                <h2 class="is cj it cm jh !my-0">What is net premium margin?</h2>
                <div style="cursor: pointer" class="a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                  <path :d="tab[10]?'M13 10L8 5L3 10':'M3 6L8 11L13 6'" stroke="#101010"></path>
                  </svg>
                </div>
              </div>
              <div v-if="tab[10]" class="a hz kv hy ii kw kx ky kz la lb lc ld le lf lg"><span class="q e f ar h">The net option premium is the total amount a trader will pay for selling one or more options and at the same time purchasing others. The combination can include any number of puts and calls and their respective position in each.</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="a bk bu">
        <div class="a jl jm jn">
          <div class="a bk jo hr hg bn">
            <div class="a jp jq jr js">
              <h2 class="q e ci cj ce">Invest Right, Invest Now</h2>
            </div>
            <div style="border: 0.5px solid #0000001a" class="bs a"></div>
            <div class="a bk jt">
              <div class="a bk co ju jv gf">
                <span class="q e f g h">Open a FREE* </span
                ><span class="q e f g h"
                  >Demat + Trading account and enjoy</span
                >
              </div>
              <div class="a ds ju bw gc by">
                <span class="q e f ar h"
                  >Zero commission* on Mutual Funds and IPO</span
                >
              </div>
              <div class="a ju bw gc by">
                <span class="q e f ar h"
                  >₹20* per order on Equity, F&amp;O, Commodity and
                  Currency</span
                >
              </div>
            </div>
            <div style="border: 0.5px solid #0000001a" class="bs a"></div>
            <div class="a bk jw">
              <div class="a jp jx jv gf">
                <span class="q e f ar h"
                  >Enter your mobile number to continue</span
                >
              </div>
              <div
                class="a jp fm cv fo fp fr jy ft fu jz ka fw fx kb fz kc kd ke"
              >
                <div class="a bk">
                  <div class="a bk gh gi gj gk">
                    <label for="mobileNumber" class="q e f g h"></label>
                    <div class="gl fg ay cr gm gn c go dr">
                      <div class="c a dr gp gq gr gs">
                        <div class="a"><span class="q e f g h">+91</span></div>
                        <input
                          type="text"
                          id="mobileNumber"
                          value=""
                          class="q e f ar gv fg bn gw gx gy gz m ha hb hc hd he hf bs a !bg-transparent !shadow-none !border-0 !p-0"
                        />
                        <div class="ev hg hh fa hi fk eb hj ez hk hl"></div>
                        <div class="a"></div>
                      </div>
                    </div>
                    <span data-qa="info-message" class="cd e au ar ce"></span>
                  </div>
                </div>
              </div>
              <div class="a jp kf">
                <button
                  type="button"
                  disabled=""
                  class="at e f x y c av ab aw i a ae af ag ah ai bn az ba bb bc bd be bf n bg bh bi"
                >
                  Start Investing
                </button>
              </div>
              <div class="a cn af kg kh ki kj kk">
                <span class="cd e gg ar ce"
                  >By signing up you agree to our<!-- -->
                  <a
                    href="/terms-of-use-and-privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                    ><span class="q e gg ar h">Terms and Conditions</span></a
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
</style>